/* eslint-disable import/prefer-default-export */
import { graphql, useStaticQuery } from 'gatsby'

export const useRatingsContent = () => {
  const data = useStaticQuery(graphql`
    query RatingsContentQuery {
      allWpPage(
        filter: {
          pageType: { taxonomy: { eq: "content" } }
          filterargument: { filterargument: { eq: "ratings" } }
        }
      ) {
        nodes {
          id
          pageType {
            taxonomy
          }
          title
          language {
            slug
          }
          filterargument {
            filterargument
          }
          ratingscontent {
            title
            kicker
            heading
            rating1 {
              rating
              scale
              title
              link
            }
            rating2 {
              rating
              scale
              title
              link
            }
            rating3 {
              rating
              scale
              title
              link
            }
            background {
              node {
                altText
                sourceUrl
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      quality: 80
                      webpOptions: { quality: 80 }
                      avifOptions: { lossless: true, quality: 80 }
                    )
                  }
                }
                mediaItemUrl
                mediaType
              }
            }
          }
        }
      }
    }
  `)

  return data.allWpPage.nodes
}
